export const REFERRAL_CODE_REASON = {
    GET_EMPTY_REFERRAL_CODE: 'Get empty referral code.',
    SUBMIT_FAILED: 'Submit failed.'
};

export const REFERRAL_CODE_API_FAIL_REASON = {
    REFERRAL_CODE_NOT_FOUND: 'referral code not found',
    CAN_NOT_USE_SELF_REFERRAL_CODE: 'member can not input self referral code'
};
